<template>
    <div class="widget" :class="{ 'is-loading': isLoading }">
        <h3>Opname status</h3>

        <div class="widget__inner">
            <div class="row">
                <div class="col-6">
                    <div class="pie-chart" style="max-height: 240px; overflow: hidden;">
                        <highcharts :options="chartData" ref="highcharts" style="height: 260px;"></highcharts>
                    </div>
                </div>

                <div class="col-6 ml-auto">
                    <h3>Opnames</h3>

                    <ul class="amounts">
                        <li>
                            <p>Gepland</p>
                            <strong>{{ inspectionStatus.amounts.planned | formatNumber }}</strong>
                        </li>

                        <li>
                            <p>Lopend</p>
                            <strong>{{ inspectionStatus.amounts.processing | formatNumber }}</strong>
                        </li>

                        <li>
                            <p>Afgerond</p>
                            <strong>{{ inspectionStatus.amounts.completed | formatNumber }}</strong>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import Vue from 'vue'
	import Highcharts from 'highcharts'
	import VueHighcharts from 'highcharts-vue'
	import { mapGetters } from 'vuex'
	import { FETCH_INSPECTION_STATUS } from '@/store/modules/widgets'

	Highcharts.setOptions({
		lang: {
			decimalPoint: ',',
			thousandsSep: '.',
		},
	})

	Vue.use(VueHighcharts, { highcharts: Highcharts })

	let chartData = {
		credits: false,

		chart: {
			type: 'pie',
		},

		title: {
			text: '',
		},

		plotOptions: {
			series: {
				dataLabels: {
					enabled: false,
					format: '{point.name}: {point.y:.1f}%',
				},
			},
			pie: {
				colors: ['rgba(241, 137, 3, 0.4)', 'rgba(241, 137, 3, 0.6)', '#F18903'],
			},
		},

		tooltip: {
			headerFormat: '<span></span>',
			pointFormat: '<span>{point.name}</span>: <b>{point.y:.1f}%</b><br/>',
		},

		series: [
			{
				name: 'Apparaat',
				data: [],
			},
		],
	}

	export default {
//		components: { Highcharts },

		data () {
			return {
				isLoading: true,
				chartData: chartData,
			}
		},

		computed: {
			...mapGetters([
				'inspectionStatus',
			]),
		},

		mounted () {
			this.fetchData()
		},

		methods: {
			fetchData () {
				this.$store.dispatch(FETCH_INSPECTION_STATUS).then((data) => {
					this.chartData.series[0].data = data.percentages
					this.isLoading = false
				})

			},
		},
	}
</script>

<style lang="scss" scoped>
    .amounts {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 0;
            border-bottom: 1px solid #e6e6e6;

            p {
                margin-bottom: 0;
            }

            strong {
                font-size: 22px;
            }
        }
    }
</style>